(function(){
  'use strict';

  // ── DOM refs ──
  const $ = s => document.querySelector(s);
  const $$ = s => document.querySelectorAll(s);

  // ── State — initialised from the active server-rendered variant button.
  //    Never hardcode product-specific defaults (used to be 150g / ₹349 — that
  //    broke pricing on every product except Dosa). ────────────────────────
  function readActiveVariantFromDom(){
    const btn = document.querySelector('.variant-btn.active') || document.querySelector('.variant-btn');
    if (!btn) {
      // No variant picker on page — fall back to DOM-rendered prices.
      const priceText = (document.getElementById('priceNow') || {}).textContent || '0';
      const mrpText   = (document.getElementById('priceMrp') || {}).textContent || '';
      const offText   = (document.getElementById('priceOff') || {}).textContent || '';
      const toInt = s => parseInt(String(s).replace(/[^0-9]/g, ''), 10) || 0;
      return {
        size: '',
        price: toInt(priceText),
        mrp:   toInt(mrpText),
        off:   toInt(offText)
      };
    }
    return {
      size:  btn.dataset.size  || '',
      price: parseInt(btn.dataset.price, 10) || 0,
      mrp:   parseInt(btn.dataset.mrp,   10) || 0,
      off:   parseInt(btn.dataset.off,   10) || 0
    };
  }

  let currentVariant = readActiveVariantFromDom();
  let quantity = 1;
  let subscribed = false;
  let cartCount = 0;

  // ══════════════ IMAGE GALLERY ══════════════
  // NOTE: Gallery click handling is now owned by the inline script in
  // sections/rc-main-product.liquid (data-gallery, data-gallery-prev/next,
  // data-thumbs-prev/next). Keep this block disabled so we don't double-bind.
  const galleryImgs = [];
  const thumbs = [];
  function setActiveImage(){ /* delegated to inline script */ }

  // ══════════════ VARIANT PICKER ══════════════
  const variantBtns = $$('.variant-btn');
  const variantName = $('#variantName');
  const priceNow = $('#priceNow');
  const priceMrp = $('#priceMrp');
  const priceOff = $('#priceOff');
  const ctaPrice = $('#ctaPrice');
  const stickyPrice = $('#stickyPrice');
  const stickyVariant = $('#stickyVariant');
  const subPriceEl = $('#subPrice');

  function updatePrices(){
    // Subscribe discount only kicks in when MRP > 0 and price > 0
    const baseP = currentVariant.price || 0;
    const mrp   = currentVariant.mrp   || 0;
    const p     = subscribed && baseP > 0 ? Math.round(baseP * 0.9) : baseP;
    const total = p * quantity;
    const mrpTotal = mrp * quantity;

    // BIG top price shows TOTAL (unit × qty) so qty changes are always visible
    if (priceNow) priceNow.textContent = '₹' + total;
    if (priceMrp) priceMrp.textContent = mrpTotal > total ? '₹' + mrpTotal : '';
    if (priceOff) {
      const offPct = mrpTotal > total ? Math.round((1 - total / mrpTotal) * 100) : 0;
      priceOff.textContent = offPct > 0 ? offPct + '% OFF' : '';
    }
    if (ctaPrice)    ctaPrice.textContent    = '₹' + total;
    if (stickyPrice) stickyPrice.textContent = '₹' + total;
    if (variantName && currentVariant.size) variantName.textContent = currentVariant.size;

    if (subPriceEl) {
      if (subscribed) {
        subPriceEl.style.display = 'inline';
        subPriceEl.textContent = '₹' + total;
      } else {
        subPriceEl.style.display = 'none';
      }
    }
  }

  // The variant button click handler is owned by window.rcMpSelectVariant
  // (defined inline in sections/rc-main-product.liquid). We hook into it
  // here so quantity-based totals stay in sync with the selected variant.
  if (typeof window !== 'undefined') {
    const originalSelect = window.rcMpSelectVariant;
    window.rcMpSelectVariant = function (btn) {
      if (typeof originalSelect === 'function') originalSelect(btn);
      if (!btn) return;
      currentVariant = {
        size:  btn.dataset.size  || '',
        price: parseInt(btn.dataset.price, 10) || 0,
        mrp:   parseInt(btn.dataset.mrp,   10) || 0,
        off:   parseInt(btn.dataset.off,   10) || 0
      };
      // Re-apply qty multiplier with the new variant price.
      updatePrices();
    };
  }

  // ══════════════ QUANTITY ══════════════
  const qtyNum = $('#qtyNum');
  const qtyMinus = $('#qtyMinus');
  const qtyPlus = $('#qtyPlus');
  const stickyQtyEl = $('#stickyQty');
  const stickyMinusBtn = $('#stickyMinus');
  const stickyPlusBtn = $('#stickyPlus');
  const hiddenQtyInput = $('#rcMpQty');

  // Seed from DOM in case server-rendered qty differs from default 1
  if (qtyNum) {
    const initial = parseInt(qtyNum.textContent, 10);
    if (!isNaN(initial) && initial >= 1) quantity = initial;
  }

  function updateQty(delta){
    quantity = Math.max(1, Math.min(10, quantity + delta));
    if (qtyNum)         qtyNum.textContent       = quantity;
    if (stickyQtyEl)    stickyQtyEl.textContent  = quantity;
    if (qtyMinus)       qtyMinus.disabled        = quantity <= 1;
    if (qtyPlus)        qtyPlus.disabled         = quantity >= 10;
    if (hiddenQtyInput) hiddenQtyInput.value     = quantity;
    updatePrices();
  }

  if (qtyMinus)        qtyMinus.addEventListener('click', () => updateQty(-1));
  if (qtyPlus)         qtyPlus.addEventListener('click',  () => updateQty(1));
  if (stickyMinusBtn)  stickyMinusBtn.addEventListener('click', () => updateQty(-1));
  if (stickyPlusBtn)   stickyPlusBtn.addEventListener('click',  () => updateQty(1));

  // Initial sync — important: the DOM is server-rendered with correct prices,
  // but currentVariant came from data attributes which might differ slightly
  // due to subscribe state. Call once so CTA / sticky reflect price × qty.
  updatePrices();

  // ══════════════ SUBSCRIBE TOGGLE ══════════════
  const subToggle = $('#subToggle');
  if (subToggle) {
    subToggle.addEventListener('change', () => {
      subscribed = subToggle.checked;
      updatePrices();
    });
  }

  // ══════════════ ADD TO CART (visual feedback only — actual cart submit
  // is handled by the form handler in rc-main-product.liquid) ════════════
  function handleAddToCart(){
    cartCount += quantity;
    const badge = $('#cartBadge');
    if (badge) badge.textContent = cartCount;
    const btn = $('#addToCart');
    if (!btn) return;
    const origHTML = btn.innerHTML;
    btn.innerHTML = '✓ Added to Cart!';
    btn.style.background = 'var(--green)';
    btn.style.color = 'white';
    setTimeout(() => {
      btn.innerHTML = origHTML;
      btn.style.background = '';
      btn.style.color = '';
      updatePrices();
    }, 1800);
  }

  const addCartBtn = $('#addToCart');
  const stickyAtcBtn = $('#stickyAtc');
  if (stickyAtcBtn) stickyAtcBtn.addEventListener('click', handleAddToCart);

  // ══════════════ STICKY BAR ══════════════
  const stickyBar = $('#stickyBar');
  const ctaBlock = $('#ctaBlock');

  if (stickyBar && ctaBlock && 'IntersectionObserver' in window) {
    const stickyObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const shouldShow = !entry.isIntersecting && window.scrollY > 300;
        stickyBar.classList.toggle('visible', shouldShow);
      });
    }, { threshold: 0, rootMargin: '-70px 0px 0px 0px' });
    stickyObserver.observe(ctaBlock);

    window.addEventListener('scroll', () => {
      if(window.scrollY <= 300) stickyBar.classList.remove('visible');
    }, { passive: true });
  }

  // ══════════════ NAV SCROLL ══════════════
  const nav = $('#nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  // ══════════════ NUTRITION TABLE — REDESIGNED ══════════════
  const nutriData = {
    '100g': [
      { name:'Energy', amount:'385 kcal / 1611 kJ', dv:'19', highlight:false },
      { name:'Protein', amount:'24.41g', dv:'49', highlight:true },
      { name:'Total Carbohydrate', amount:'65.93g', dv:'0', highlight:false },
      { name:'Total Sugars', amount:'0g', dv:'0', highlight:false, badge:'ZERO', sub:true },
      { name:'Added Sugars', amount:'0g', dv:'0', highlight:false, badge:'ZERO', sub:true },
      { name:'Dietary Fibre (Total)', amount:'8.19g', dv:'33', highlight:true },
      { name:'Total Fat', amount:'2.61g', dv:'4', highlight:false },
      { name:'Saturated Fat', amount:'0.54g', dv:'2', highlight:false, badge:'LOW', sub:true },
      { name:'Trans Fat', amount:'0g', dv:'0', highlight:false, badge:'ZERO', sub:true },
      { name:'Cholesterol', amount:'0 mg', dv:'0', highlight:false },
      { name:'Total Salt', amount:'0.23g', dv:'5', highlight:false },
      { name:'Sodium', amount:'92.6 mg', dv:'5', highlight:false },
      { name:'Magnesium', amount:'135 mg', dv:'40', highlight:true },
    ],
    'serving': [
      { name:'Energy', amount:'192 kcal / 805 kJ', dv:'10', highlight:false },
      { name:'Protein', amount:'12.21g', dv:'24', highlight:true },
      { name:'Total Carbohydrate', amount:'32.97g', dv:'0', highlight:false },
      { name:'Total Sugars', amount:'0g', dv:'0', highlight:false, badge:'ZERO', sub:true },
      { name:'Added Sugars', amount:'0g', dv:'0', highlight:false, badge:'ZERO', sub:true },
      { name:'Dietary Fibre (Total)', amount:'4.10g', dv:'16', highlight:true },
      { name:'Total Fat', amount:'1.31g', dv:'2', highlight:false },
      { name:'Saturated Fat', amount:'0.27g', dv:'1', highlight:false, badge:'LOW', sub:true },
      { name:'Trans Fat', amount:'0g', dv:'0', highlight:false, badge:'ZERO', sub:true },
      { name:'Cholesterol', amount:'0 mg', dv:'0', highlight:false },
      { name:'Total Salt', amount:'0.12g', dv:'2', highlight:false },
      { name:'Sodium', amount:'46.3 mg', dv:'2', highlight:false },
      { name:'Magnesium', amount:'67.5 mg', dv:'20', highlight:true },
    ]
  };

  // SVG ring helper
  const RING_R = 14, RING_C = 2 * Math.PI * RING_R;
  function ringSVG(pct){
    const offset = RING_C - (Math.min(pct,100)/100) * RING_C;
    return `<svg viewBox="0 0 36 36"><circle class="nt-ring-bg" cx="18" cy="18" r="${RING_R}"/><circle class="nt-ring-fill" cx="18" cy="18" r="${RING_R}" stroke-dasharray="${RING_C}" stroke-dashoffset="${RING_C}" data-target="${offset}"/></svg>`;
  }

  function renderNutri(view){
    const body = $('#nutriBody');
    if (!body) return;
    body.innerHTML = nutriData[view].map(r => {
      const dvNum = parseInt(r.dv) || 0;
      const dvDisplay = dvNum > 0 ? dvNum + '%' : '—';
      const badgeClass = r.badge === 'ZERO' ? 'nt-badge-zero' : r.badge === 'LOW' ? 'nt-badge-low' : '';
      const highlightClass = r.highlight ? 'nt-highlight' : '';
      const subClass = r.sub ? 'nt-sub' : '';
      return `<tr class="${highlightClass} ${subClass}"><td colspan="3"><div class="nt-row-inner"><span class="nt-name">${r.name}${r.badge ? '<span class="nt-badge '+badgeClass+'">'+r.badge+'</span>' : ''}</span><span class="nt-amount">${r.amount}</span>${dvNum > 0 ? '<div class="nt-ring">'+ringSVG(dvNum)+'</div>' : '<div class="nt-ring" style="opacity:0"></div>'}<span class="nt-rda">${dvDisplay}</span></div></td></tr>`;
    }).join('');

    // Animate rings
    setTimeout(() => {
      document.querySelectorAll('.nt-ring-fill').forEach(c => {
        c.style.strokeDashoffset = c.dataset.target;
      });
    }, 50);
  }

  renderNutri('100g');

  $$('.nutri-tab').forEach(tab => {
    tab.addEventListener('click', () => {
      $$('.nutri-tab').forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      renderNutri(tab.dataset.view);

      // Update hero stat cards for serving
      const isServing = tab.dataset.view === 'serving';
      const heroCards = $$('.nhs-value[data-count]');
      const servingVals = ['12.2','192','4.1','67.5'];
      const fullVals = ['24.4','385','8.2','135'];
      const servingRda = ['24% RDA','10% RDA','16% RDA','20% RDA'];
      const fullRda = ['49% RDA','19% RDA','33% RDA','40% RDA'];
      const vals = isServing ? servingVals : fullVals;
      const rdas = isServing ? servingRda : fullRda;
      heroCards.forEach((el,i) => {
        const target = parseFloat(vals[i]);
        animateCounter(el, target);
      });
      $$('.nhs-rda').forEach((el,i) => el.textContent = rdas[i]);
    });
  });

  // Counter animation
  function animateCounter(el, target){
    const unit = el.querySelector('.nhs-unit');
    const unitText = unit ? unit.textContent : '';
    const duration = 600;
    const start = performance.now();
    const startVal = parseFloat(el.textContent) || 0;
    const isDecimal = String(target).includes('.');

    function tick(now){
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = startVal + (target - startVal) * eased;
      el.innerHTML = (isDecimal ? current.toFixed(1) : Math.round(current)) + '<span class="nhs-unit">' + unitText + '</span>';
      if(progress < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  // Animate hero counters on scroll
  const nhsObserver = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if(e.isIntersecting){
        $$('.nhs-value[data-count]').forEach(el => {
          animateCounter(el, parseFloat(el.dataset.count));
        });
        nhsObserver.unobserve(e.target);
      }
    });
  }, { threshold: 0.3 });
  const nhsEl = $('#nutriHeroStats');
  if(nhsEl) nhsObserver.observe(nhsEl);

  // ── Ingredients toggle ──
  const ingToggle = $('#ingredientsToggle');
  const ingBody = $('#ingredientsBody');
  if (ingToggle && ingBody) {
    ingToggle.addEventListener('click', () => {
      ingToggle.classList.toggle('open');
      ingBody.classList.toggle('open');
    });
  }

  // ══════════════ REVEAL ON SCROLL ══════════════
  const rvObserver = new IntersectionObserver(entries => {
    entries.forEach(e => { if(e.isIntersecting){ e.target.classList.add('in'); rvObserver.unobserve(e.target); }});
  }, { threshold: 0.15 });

  $$('.rv').forEach(el => rvObserver.observe(el));

  // ══════════════ EXPLORE CAROUSEL ══════════════
  // Pagination model: group cards into "pages" based on how many fit in
  // the viewport. One dot per page (NOT one dot per card) so the user
  // only needs N scroll actions instead of <total-cards> actions.
  const explCarousel = $('#exploreCarousel');
  const explCards    = explCarousel ? Array.prototype.slice.call(explCarousel.querySelectorAll('.explore-card')) : [];
  const explDotsRoot = $('#explDots');
  const explCounter  = $('#explCurrent');
  const explPrev     = $('#explPrev');
  const explNext     = $('#explNext');
  let   explIndex    = 0;
  let   explPages    = []; // each entry = scrollLeft target for that page
  let   explDots     = []; // re-generated dots, one per page

  function cardsPerPage(){
    if (!explCarousel || !explCards.length) return 1;
    const cWidth   = explCarousel.clientWidth;
    const cardW    = explCards[0].getBoundingClientRect().width;
    // gap is the difference between two consecutive cards' offsetLeft
    const gap      = explCards.length > 1 ? (explCards[1].offsetLeft - explCards[0].offsetLeft - cardW) : 0;
    const perPage  = Math.max(1, Math.floor((cWidth + gap) / (cardW + gap)));
    return perPage;
  }

  function buildExplPages(){
    if (!explCarousel || !explCards.length) { explPages = []; return; }
    const perPage = cardsPerPage();
    const totalPages = Math.max(1, Math.ceil(explCards.length / perPage));
    explPages = [];
    for (let p = 0; p < totalPages; p++) {
      const cardIdx = Math.min(p * perPage, explCards.length - 1);
      const target  = explCards[cardIdx].offsetLeft;
      explPages.push(target);
    }
    rebuildDots(totalPages);
  }

  function rebuildDots(count){
    if (!explDotsRoot) return;
    explDotsRoot.innerHTML = '';
    for (let i = 0; i < count; i++) {
      const dot = document.createElement('span');
      dot.className = 'explore-dot' + (i === explIndex ? ' active' : '');
      dot.addEventListener('click', () => scrollToExplPage(i));
      explDotsRoot.appendChild(dot);
    }
    explDots = Array.prototype.slice.call(explDotsRoot.querySelectorAll('.explore-dot'));
  }

  function setExplActive(idx){
    explIndex = Math.max(0, Math.min(idx, explPages.length - 1));
    explDots.forEach((d,i) => d.classList.toggle('active', i === explIndex));
    if (explCounter) explCounter.textContent = explIndex + 1;
    // Update the "X / Y Categories" total too
    const counterParent = explCounter ? explCounter.parentNode : null;
    if (counterParent && explPages.length) {
      const html = counterParent.innerHTML;
      counterParent.innerHTML = html.replace(/\/\s*\d+/, '/ ' + explPages.length);
    }
  }

  function scrollToExplPage(idx){
    if (!explCarousel || !explPages.length) return;
    idx = Math.max(0, Math.min(idx, explPages.length - 1));
    const target = explPages[idx];
    if (typeof explCarousel.scrollTo === 'function') {
      explCarousel.scrollTo({ left: target, behavior: 'smooth' });
    } else {
      explCarousel.scrollLeft = target;
    }
    setExplActive(idx);
  }

  // Build pages on init, update on resize
  if (explCarousel && explCards.length) {
    buildExplPages();
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(buildExplPages, 150);
    });
  }

  if (explNext) explNext.addEventListener('click', () => scrollToExplPage(explIndex + 1));
  if (explPrev) explPrev.addEventListener('click', () => scrollToExplPage(explIndex - 1));

  // Auto-sync active page on manual scroll (touch / drag / wheel)
  if (explCarousel && explCards.length) {
    let explScrollTimer;
    explCarousel.addEventListener('scroll', () => {
      clearTimeout(explScrollTimer);
      explScrollTimer = setTimeout(() => {
        const sx = explCarousel.scrollLeft;
        let nearest = 0, minDiff = Infinity;
        for (let i = 0; i < explPages.length; i++) {
          const diff = Math.abs(explPages[i] - sx);
          if (diff < minDiff) { minDiff = diff; nearest = i; }
        }
        if (nearest !== explIndex) setExplActive(nearest);
      }, 80);
    }, { passive: true });
  }

  // 3D Tilt effect on cards
  $$('[data-tilt]').forEach(card => {
    card.addEventListener('mousemove', e => {
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;
      const rotateX = ((y - centerY) / centerY) * -6;
      const rotateY = ((x - centerX) / centerX) * 6;
      card.style.transform = `translateY(-10px) scale(1.02) perspective(800px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
    });
    card.addEventListener('mouseleave', () => {
      card.style.transform = '';
    });
  });

  // Drag-to-scroll for carousel — only if the carousel actually exists.
  if (explCarousel) {
    let isDragging = false, startX, scrollLeftStart, hasMoved = false;
    explCarousel.addEventListener('mousedown', e => {
      isDragging = true;
      hasMoved = false;
      startX = e.pageX - explCarousel.offsetLeft;
      scrollLeftStart = explCarousel.scrollLeft;
      explCarousel.style.cursor = 'grabbing';
    });
    explCarousel.addEventListener('mouseleave', () => { isDragging = false; explCarousel.style.cursor = 'grab'; });
    explCarousel.addEventListener('mouseup',    () => { isDragging = false; explCarousel.style.cursor = 'grab'; });
    explCarousel.addEventListener('mousemove', e => {
      if(!isDragging) return;
      e.preventDefault();
      const x = e.pageX - explCarousel.offsetLeft;
      const walk = (x - startX) * 1.5;
      if (Math.abs(walk) > 4) hasMoved = true;
      explCarousel.scrollLeft = scrollLeftStart - walk;
    });
    // Prevent click navigation when user actually dragged
    explCarousel.addEventListener('click', e => {
      if (hasMoved) { e.preventDefault(); e.stopPropagation(); hasMoved = false; }
    }, true);
  }

  // ══════════════ VM TABS & INTERACTIVITY ══════════════
  const vmTabBtns = $$('.vm-tab-btn');
  const vmPanels = $$('.vm-panel');

  vmTabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      vmTabBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const target = btn.dataset.target;

      vmPanels.forEach(p => {
        if(target === 'both'){
          p.style.display = p.dataset.panel === 'both' ? '' : 'none';
        } else {
          p.style.display = p.dataset.panel === target ? '' : 'none';
        }
      });

      // Re-trigger bar animations
      setTimeout(() => animateVmBars(), 50);
    });
  });

  // VM bar animation on scroll
  function animateVmBars(){
    document.querySelectorAll('.vm-bar-fill').forEach(bar => {
      const w = bar.style.getPropertyValue('--bar-w');
      bar.style.width = '0';
      requestAnimationFrame(() => {
        requestAnimationFrame(() => { bar.style.width = w; });
      });
    });
  }

  const vmBarObserver = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if(e.isIntersecting){
        animateVmBars();
        vmBarObserver.unobserve(e.target);
      }
    });
  }, { threshold: 0.2 });

  const vmTablesEl = document.querySelector('#vmTables');
  if(vmTablesEl) vmBarObserver.observe(vmTablesEl);

  // VM row tooltip
  const vmTooltip = $('#vmTooltip');
  if (vmTooltip) {
    $$('.vm-row').forEach(row => {
      row.addEventListener('mouseenter', e => {
        const tip = row.dataset.tip;
        if(!tip) return;
        vmTooltip.textContent = tip;
        vmTooltip.style.opacity = '1';
        vmTooltip.style.transform = 'translateY(0)';
        const rect = row.getBoundingClientRect();
        vmTooltip.style.left = (rect.left + rect.width/2 - vmTooltip.offsetWidth/2) + 'px';
        vmTooltip.style.top = (rect.top - vmTooltip.offsetHeight - 10) + 'px';
      });
      row.addEventListener('mouseleave', () => {
        vmTooltip.style.opacity = '0';
        vmTooltip.style.transform = 'translateY(6px)';
      });
    });
  }

  // ── Review bars animation ──
  const barObserver = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if(e.isIntersecting){
        e.target.querySelectorAll('.rbar-fill').forEach(bar => {
          bar.style.width = bar.dataset.w + '%';
        });
        barObserver.unobserve(e.target);
      }
    });
  }, { threshold: 0.3 });

  const reviewsSummary = document.querySelector('.reviews-summary');
  if(reviewsSummary) barObserver.observe(reviewsSummary);

})();


/* ── next script block ── */


/* ── Old DISPLAY_ORDER thumbnail-reorder IIFE — disabled.
   It was hardcoded for an 8-image chilla product and broke when the
   gallery started rendering from product.images (variable count).
   Gallery navigation is now fully handled by the inline script in
   sections/rc-main-product.liquid. ──────────────────────────────── */


/* ── next script block ── */
